// Themed metatemplates for InputType 'SampleTestAcceptance' — the unified test acceptance control.
// Mirrors InputType-Picker.js's Bulma chrome (column / field / label / help) since this IS a picker, and
// adds the Remarks disclosure that shows and hides the sibling RichText remarks field.
//
// Deliberately group-weight, not section-weight: this block closes out the test above it, so it carries
// no section header treatment. The "Test Results" heading it replaced is what read as a new test.
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME — interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-SampleTestAcceptance',
			DefaultInputExtensions: [ 'SampleTestAcceptance' ],
			Template: /*HTML*/`
			<!-- InputType SampleTestAcceptance {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column test-acceptance-column {~ColumnWidth:Record~}">
				<input
					id="MATERIALS-ENTITY-TRACKING-GUID-TEST-{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					value=""
				/>
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					{~D:Record.Macro.InputChangeHandler~}
					{~Required:Record~}
					data-validation-surface="PICKER-FOR-{~D:Record.Macro.RawHTMLID~}"
					value=""
				/>
				<div class="field">
					<label class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<div class="is-flex is-align-items-flex-end">
						<p class="control control-status test-acceptance-result">
							<span class="control-status-icon"></span>
							<span id="PICKER-FOR-{~D:Record.Macro.RawHTMLID~}" class="pps-form-host" {~D:Record.Macro.ControlAttr~}></span>
						</p>
						<a id="TEST-ACCEPTANCE-REMARKS-TOGGLE-{~D:Record.Macro.RawHTMLID~}"
							class="button is-small is-ghost test-acceptance-remarks-toggle ml-2"
							title="Show or hide remarks"
							onclick="_Pict.providers.SampleTestAcceptance.toggleRemarks('{~D:Record.Hash~}')">
							<span class="icon"><i class="fas fa-fw fa-chevron-right"></i></span><span class="icon-text">Remarks</span>
						</a>
					</div>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-SampleTestAcceptance',
			DefaultInputExtensions: [ 'SampleTestAcceptance' ],
			Template: /*HTML*/`
			<!-- InputType SampleTestAcceptance {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<input
							id="MATERIALS-ENTITY-TRACKING-GUID-TEST-{~D:Record.Macro.RawHTMLID~}"
							type="hidden"
							tabindex="-1"
							value=""
						/>
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="hidden"
							tabindex="-1"
							{~D:Record.Macro.InputFullProperties~}
							{~D:Record.Macro.InputChangeHandler~}
							{~Required:Record~}
							data-validation-surface="PICKER-FOR-{~D:Record.Macro.RawHTMLID~}"
							value=""
						/>
						<div class="field">
							<div class="is-flex is-align-items-flex-end">
								<p class="control control-status test-acceptance-result">
									<span class="control-status-icon"></span>
									<span id="PICKER-FOR-{~D:Record.Macro.RawHTMLID~}" class="pps-form-host" {~D:Record.Macro.ControlAttr~}></span>
								</p>
								<a id="TEST-ACCEPTANCE-REMARKS-TOGGLE-{~D:Record.Macro.RawHTMLID~}"
									class="button is-small is-ghost test-acceptance-remarks-toggle ml-2"
									title="Show or hide remarks"
									onclick="_Pict.providers.SampleTestAcceptance.toggleRemarks('{~D:Record.Hash~}')">
									<span class="icon"><i class="fas fa-fw fa-chevron-right"></i></span><span class="icon-text">Remarks</span>
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-SampleTestAcceptance',
			DefaultInputExtensions: [ 'SampleTestAcceptance' ],
			Template: /*HTML-Partial*/`
				<!-- InputType SampleTestAcceptance (tabular) {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="field mb-0">
					<p class="control control-status">
						<span class="control-status-icon"></span>
						<input
							id="MATERIALS-ENTITY-TRACKING-GUID-TEST-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
							type="hidden"
							tabindex="-1"
							value=""
						/>
						<input
							id="PICKER-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
							type="hidden"
							tabindex="-1"
							{~Required:Record~}
							data-validation-surface="PICKER-TABULAR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
							{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-SampleTestAcceptance',
			DefaultInputExtensions: [ 'SampleTestAcceptance' ],
			Template: /*HTML-Partial*/`
							value="" />
						<span id="PICKER-TABULAR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" class="pps-form-host" {~D:Record.Macro.ControlAttr~} data-i-index="{~D:Context[2].Key~}"></span>
					</p>
				</div>`,
		},
	],
	/* READ THEME — locked in-browser state, painted by the PickerDisplay provider. The remarks field
	   renders through its own descriptor, so there is no disclosure here. */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-SampleTestAcceptance',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
			<!-- InputType SampleTestAcceptance (read display) {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="MATERIALS-ENTITY-TRACKING-GUID-TEST-{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					value=""
				/>
				<div class="field">
					<label class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control">
						<div id="PICKER-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="input" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} disabled="disabled"></div>
					</p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-SampleTestAcceptance',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
			<!-- InputType SampleTestAcceptance (read display, vertical) {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control">
								<div id="PICKER-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="input" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} disabled="disabled"></div>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-SampleTestAcceptance',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- InputType SampleTestAcceptance (tabular read) {~D:Record.Hash~} {~D:Record.DataType~} -->
				<p class="control">
					<input
						id="MATERIALS-ENTITY-TRACKING-GUID-TEST-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="hidden"
						tabindex="-1"
						value=""
					/>
					<input
						id="PICKER-TABULAR-DISPLAY-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="text"
						class="input"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}
						disabled="disabled" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-SampleTestAcceptance',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
					value="" />
				</p>`,
		},
	],
	/* PRINT THEME — non-interactive, for PDF documents. */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-SampleTestAcceptance',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
			<!-- InputType SampleTestAcceptance (print) {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<label class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control">
						<div id="PICKER-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="input is-static" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} disabled="disabled"></div>
					</p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-SampleTestAcceptance',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
			<!-- InputType SampleTestAcceptance (print, vertical) {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column">
						<div class="field">
							<p class="control">
								<div id="PICKER-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="input is-static" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} disabled="disabled"></div>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-SampleTestAcceptance',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- InputType SampleTestAcceptance (tabular print) {~D:Record.Hash~} {~D:Record.DataType~} -->
				<p class="control">
					<input
						id="PICKER-TABULAR-DISPLAY-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="text"
						class="input is-static"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}
						disabled="disabled" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-SampleTestAcceptance',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
					value="" />
				</p>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;
